import { getToken } from './auth';

const config = window.pcaSettings;

async function request(path, method = 'GET', body) {
  const token = await getToken();
  if (!token) throw new Error('Not authenticated');
  const opts = {
    method,
    headers: { Authorization: `Bearer ${token}` },
    mode: 'cors'
  };
  if (body) {
    opts.headers['Content-Type'] = 'application/json';
    opts.body = JSON.stringify(body);
  }
  const res = await fetch(`${config.api.uri}${path}`, opts);
  let data;
  try {
    data = await res.json();
  } catch (e) {
    data = undefined;
  }
  if (!res.ok) {
    const msg = (data && data.message) || res.statusText || 'Request failed';
    const err = new Error(msg);
    err.status = res.status;
    err.data = data;
    throw err;
  }
  if (res.status === 204) return;
  return data;
}

export function enableUser(username) {
  return request(`/auth/${encodeURIComponent(username)}/enable`, 'PUT');
}

export function disableUser(username) {
  return request(`/auth/${encodeURIComponent(username)}/disable`, 'PUT');
}

export function addUserToGroup(username, group) {
  return request(`/auth/${encodeURIComponent(username)}/groups/${encodeURIComponent(group)}`, 'POST');
}

export function removeUserFromGroup(username, group) {
  return request(`/auth/${encodeURIComponent(username)}/groups/${encodeURIComponent(group)}`, 'DELETE');
}

export function resetUserPassword(username, temporaryPassword) {
  return request(`/auth/${encodeURIComponent(username)}/reset-password`, 'PUT', { temporaryPassword });
}

export function deleteUser(username) {
  return request(`/auth/${encodeURIComponent(username)}`, 'DELETE');
}

export function updateUser(username, attributes) {
  return request(`/auth/${encodeURIComponent(username)}`, 'PUT', attributes);
}

export function createUser(data) {
  return request('/auth', 'POST', data);
}

export function setUserRole(username, role) {
  return request(`/auth/${encodeURIComponent(username)}/role`, 'PUT', { role });
}
